import { PureComponent } from 'react'
import { withRouter } from 'react-router'
import { Switch, Route } from 'react-router-dom'

import AppConfig from '@src/config/AppConfig'

import EmbedBillboard from '../content/billboards/EmbedBillboard'
import EnrollmentPage from '../enrollment/EnrollmentPage'
import AccountSelector from '../routes/AccountSelector'
import ForgotPassword from '../routes/ForgotPassword'
import Login from '../routes/Login'
import NotFound from '../routes/NotFound'
import OmniauthLoginRedirect from '../routes/OmniauthLoginRedirect'
import RequestAccess from '../routes/RequestAccess'

import CommonRoute from './CommonRoute'
import MainNavRoutes from './MainNavRoutes'
import RedirectHandler, { redirectHandlerPaths } from './RedirectHandler'

export class BaseRoutes extends PureComponent {
  componentWillUnmount() {
    if (this.unsubscribeFromHistory) {
      this.unsubscribeFromHistory()
    }
  }
  render() {
    return (
      <Switch>
        <CommonRoute
          path={redirectHandlerPaths.root.path}
          component={RedirectHandler}
          requiresAuthentication
        />
        <CommonRoute
          component={AccountSelector}
          path={'/retailer/accountSelector'}
          requiresAuthentication={true}
        />
        <CommonRoute
          component={MainNavRoutes}
          path={'/retailer'}
          requiresAuthentication={true}
        />

        {AppConfig.USE_OMNIAUTH_LOGIN ? (
          <Route path="/login" exact component={OmniauthLoginRedirect} />
        ) : (
          <CommonRoute component={Login} exact={true} path={'/login'} />
        )}

        <CommonRoute
          component={RequestAccess}
          exact={true}
          path={'/request-access'}
        />
        <CommonRoute
          component={ForgotPassword}
          exact={true}
          path={'/forgot-password'}
        />
        <CommonRoute
          component={EnrollmentPage}
          exact={true}
          path={'/enroll/:brandId/:registrationKey'}
        />
        <CommonRoute
          component={EmbedBillboard}
          exact={true}
          path={'/embed-billboard'}
        />
        <Route component={NotFound} />
      </Switch>
    )
  }
}

export default withRouter(BaseRoutes)
